import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18nModule, UrlModule, CmsConfig, ConfigModule, OccConfig } from '@spartacus/core';
import { SpinnerModule, IconModule, CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { CustomUserPaymentsComponent } from './components/custom-user-payments/custom-user-payments.component';
import { CustomUserPaymentsAdapter } from './custom-user-payments.adapter';
import { CustomUserPaymentsEffects } from './store/custom-user-payments.effects';
import { customUserPaymentsFeatureKey, customUserPaymentsReducer } from './store/custom-user-payments.reducer';
import { CustomUserPaymentsDetailsComponent } from './components/custom-user-payments-details/custom-user-payments-details.component';
import { AuthGuard } from '@spartacus/core';
import { CustomUserPaymentsAvisComponent } from './components/custom-user-payments-avis/custom-user-payments-avis.component';
import { UigCustomUserPaymentsGuard } from './uig-custom-user-payments.guard';


@NgModule({
  declarations: [CustomUserPaymentsComponent, CustomUserPaymentsDetailsComponent, CustomUserPaymentsAvisComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'userPaymentsDetails' },
      },
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'userPaymentsAvis' },
      },
    ]),
    RouterModule,
    I18nModule,
    SpinnerModule,
    FormsModule,
    NgSelectModule,
    UrlModule,
    IconModule,
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            customUserPayments: '/myrio/userPayments',
            customSearchUserPayments: '/myrio/userPayments/search',
            customUserPaymentsDownload: '/myrio/userPayments/download',
            customUserPaymentsPdf: '/myrio/userPayments/pdf',
            customUserPaymentsDetails: '/myrio/userPayments/view/detail/${invoiceNumber}/${companyCode}/${bookingYear}/${bookingTime}',
            customUserPaymentsDetailsDownload: '/myrio/userPayments/view/${invoiceNumber}/${companyCode}/${bookingYear}/${bookingTime}/download',
            customUserPaymentsAvis: '/myrio/userPayments/view/avis/${avisNumber}/${avisDate}'
          },
        },
      },
    } as OccConfig),
    ConfigModule.withConfig({
      cmsComponents: {
        UserPaymentsComponent: {
          component: CustomUserPaymentsComponent,
          guards :[AuthGuard ,UigCustomUserPaymentsGuard]
        },
        UserPaymentsDetailsComponent: {
          component: CustomUserPaymentsDetailsComponent,
          guards :[AuthGuard ,UigCustomUserPaymentsGuard]
        },
        UserPaymentsAvisComponent: {
          component: CustomUserPaymentsAvisComponent,
          guards :[AuthGuard ,UigCustomUserPaymentsGuard]
        },
      }
    } as CmsConfig),
    StoreModule.forFeature(
      customUserPaymentsFeatureKey,
      customUserPaymentsReducer
    ),
    EffectsModule.forFeature([CustomUserPaymentsEffects])
  ],
  providers: [
      {
        provide: CustomUserPaymentsAdapter,
        useClass: CustomUserPaymentsAdapter,
      },
  ],
})
export class CustomUserPaymentsModule { }
